module.exports = __webpack_public_path__ + "img/qunliao.605903a3.svg";